/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RoleClaimDtoFromJSON(json) {
    return RoleClaimDtoFromJSONTyped(json, false);
}
export function RoleClaimDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'module': !exists(json, 'module') ? undefined : json['module'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function RoleClaimDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'module': value.module,
        'value': value.value,
    };
}
